module.exports = __webpack_public_path__ + "img/diretor_presidente.b77a19fb.png";